import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CommonService } from 'src/@services/common.service';
import { EndPoints } from 'src/@shared/shared/enum';

@Injectable({
  providedIn: 'root',
})
export class AuthApiClient {
  constructor(private commonService: CommonService) {}

  login(payload: unknown): Observable<unknown> {
    return this.commonService.API_POST(EndPoints.Login, payload, false);
  }

  logout(payload?: unknown): Observable<unknown> {
    return this.commonService.API_POST(EndPoints.LogOut, payload, false);
  }
}
